export const MEDIA_DETAIL_PANEL_WIDTH = "448px";

// Side by side once the parent is wide enough for the panel plus a preview.
// A container query, not a viewport query, so a narrow embed stays stacked
// on a wide screen.
export const MEDIA_DETAIL_CONTAINER = "media-detail";
export const MEDIA_DETAIL_SPLIT_QUERY =
  "@container media-detail (min-width: 700px)";

// Shared by `MediaDetailField` and its skeleton so the two rows line up.
export const MEDIA_DETAIL_FIELD_GRID = {
  display: "grid",
  gridTemplateColumns: "130px minmax(0, 1fr)",
  columnGap: 3,
  py: 1,
} as const;

export const MEDIA_DETAIL_FIELD_LABEL = {
  size: "sm",
  color: "text.tertiary",
} as const;
